import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getBracket } from "data/Querys";
import NotAvailable from 'components/common/NotAvailable'
import Loader from 'components/general/Loader';
import { getLongEventRSC } from "helpers/rsc";
import { getSportCodeObject } from "components/common/SportCode";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BracketDraw from "pages/sports/BracketDraw";
import useViewport from "components/general/useViewPort";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { LegendProvider } from "components/common/legendContext";
import { CleanLegends } from "components/common/CleanLegends";
import { LegendsBox } from "components/common/LegendsBox";


function Bracket() {
    const { breakPoint } = useViewport();
    const { mirs_competition, mirs_event, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const [dataSportCodes, setDataSportCodes] = useState()
    const [bracketKey, setBracketKey] = useState('FNL')
    const queryClient = useQueryClient();
    const hidePageHeader = '|CLB|'.includes(mirs_discipline)

    useEffect(() => {
        window.scrollTo(0, 0)
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])

    //data from ODF 
    //Load data bracket
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['bracketData', mirs_competition, getLongEventRSC(mirs_event), mirs_language],
            queryFn: getBracket,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    if (isError) { return <NotAvailable label={"LabelNoDataBracket"} />; }
    if (isLoading) { return <Loader />; }

    let dataFilter

    let dataBracketClone = data?.bracket ? JSON.parse(JSON.stringify(data?.bracket)) : undefined;

    let bronzeBracket = dataBracketClone?.filter(bracket => bracket?.bracketCode === 'BRN' || bracket?.bracketCode === 'CFNL')
    let twoFinals = dataBracketClone?.find(bracket => /CSL.X.+/.test(bracket?.code) && bracket?.bracketCode === 'FNL')?.bracketPhases?.find(phase => phase?.phaseCode === 'FNL-')
    const isWfeIndiv = !/WFE.TEAM.+/.test(mirs_event) && /WFE.+/.test(mirs_event);

    if (twoFinals) {
        let smallFinal = { ...twoFinals?.bracketItems?.find(x => /CSL...................FNL-000200--/.test(x?.eventUnit?.code)) }
        smallFinal = { ...smallFinal, bi_position: '3' }

        let bigFinal = [...twoFinals?.bracketItems?.filter(x => !/CSL...................FNL-000200--/.test(x?.eventUnit?.code))]
        twoFinals.bracketItems = bigFinal

        let bracketFNL = dataBracketClone

        //Change position
        let goldItem = { ...bracketFNL.find(x => x.bracketCode === 'FNL')?.bracketPhases.find(x => x.phaseCode === 'FNL-')?.bracketItems[0], bi_position: '2' }
        let competitors = [
            {
                "participant": {
                    "code": "NONE",
                },
                "resultItem": null
            },
            {
                "participant": {
                    "code": "NONE",
                },
                "resultItem": null
            }
        ]

        //Create an empty match 
        let blankItem = { code: "CLEAN", bi_position: "1", bracketCompetitors: competitors }
        let phases = []

        //get all phases in bracket FNL  except final 
        phases = bracketFNL.find(x => x.bracketCode === 'FNL')?.bracketPhases?.filter(z => z.phaseCode !== 'FNL-')

        //push final phase whit matches modified
        phases && phases.push(
            {
                ...bracketFNL.find(phase => phase.bracketCode === 'FNL')?.bracketPhases.find(items => items.items === 'FNL-')
                , phaseCode: 'FNL-'
                , bracketItems: [{ ...blankItem }, { ...goldItem }, { ...smallFinal }] //add matches modified
            }
        )

        dataFilter = [{
            ...bracketFNL.find(x => x.bracketCode === 'FNL'), //pirmer elemento (solo tiene 1)
            bracketPhases: phases
        }]
    } else if (isWfeIndiv) {
        //dataFilter = Array.isArray(data?.bracket) ? [...data?.bracket?.filter(bracket => bracket.bracketCode === 'FNL'), ...data?.bracket?.filter(bracket => bracket.bracketCode === 'BRN')] : []
        dataFilter = dataBracketClone //Brackets as  file
    } else if (bronzeBracket && bronzeBracket.find(x => x.bracketCode === 'BRN' || x.bracketCode === 'CFNL')) { ////Si tiene Bronce
        let bronzeItems = { ...bronzeBracket.find(x => x.bracketCode === 'BRN' || x.bracketCode === 'CFNL')?.bracketPhases.find(x => x.phaseCode === 'FNL-')?.bracketItems.find(x => x !== undefined) }
        //Change position 
        bronzeItems = { ...bronzeItems, bi_position: '3' }
        //remove brackets Bronze
        let bracketFNL = dataBracketClone.filter(bracket => bracket.bracketCode !== 'BRN' || bracket?.bracketCode === 'CFNL')
        //Change position
        let goldItems = { ...bracketFNL.find(x => x.bracketCode === 'FNL')?.bracketPhases.find(x => x.phaseCode === 'FNL-')?.bracketItems.find(x => x.bi_position === "1"), bi_position: '2' }
        let competitors = [
            {
                "participant": {
                    "code": "NONE",
                },
                "resultItem": null
            },
            {
                "participant": {
                    "code": "NONE",
                },
                "resultItem": null
            }
        ]

        //Create an emty match 
        let blankItem = { code: "CLEAN", bi_position: "1", bracketCompetitors: competitors }
        let phases = []

        //get all phases in bracket FNL  except final 
        phases = bracketFNL.find(x => x.bracketCode === 'FNL')?.bracketPhases?.filter(z => z.phaseCode !== 'FNL-')

        //push final phase whit matches modified
        phases && phases.push(
            {
                ...bracketFNL.find(phase => phase.bracketCode === 'FNL')?.bracketPhases.find(items => items.items === 'FNL-')
                , phaseCode: 'FNL-'
                , bracketItems: [{ ...blankItem }, { ...goldItems }, { ...bronzeItems }] //add matches modified
            }
        )

        dataFilter = [{
            ...bracketFNL.find(x => x.bracketCode === 'FNL'), //pirmer elemento (solo tiene 1)
            bracketPhases: phases
        }]

    } else {
        dataFilter = dataBracketClone?.filter(bracket => bracket.bracketCode === 'FNL')
    }

    //All brackets no FNL or BRN  + bracket FNL  modified (Added BRN Bracket together )
    dataFilter = isWfeIndiv ? dataFilter : Array.isArray(dataBracketClone)
        ? [...dataBracketClone?.filter(bracket => bracket.bracketCode !== 'FNL' && bracket.bracketCode !== 'BRN' && bracket?.bracketCode !== 'CFNL'), ...dataFilter]
        : []

    let numMatchs = null
    if (dataFilter?.length) {
        //Configuraciones para hacer el merge de dos brckets 
        //data,bracket sobre el que se va hacer el merge ,bracket que se borra y se mete en el anterior,fase que se solapa (Caso solapar 1 fase)
        switch (mirs_discipline) {
            case 'RU7':
                dataFilter = BracketFusionFinal(dataFilter, '5_8', '7_8', 'FNL-')
                dataFilter = BracketFusionFinal(dataFilter, '9_12', '11_12', 'FNL-')
                break;
            case 'TKW':
                /* if (!isParalympic) {
                    dataFilter = BracketFusionSeveralPhases(dataFilter, 'BRN1', 'BRN2', ['REPF', 'REP1'])
                    numMatchs = [4, 2]
                } */
                break;
            case 'JUD':
                /* dataFilter = BracketFusionSeveralPhases(dataFilter, 'BRN1', 'BRN2', ['REPF', 'REP1'])
                numMatchs = [4, 2] */
                break;
            case 'WBK':
                dataFilter = BracketFusionFinal(dataFilter, '5_8', '7_8', 'FNL-')
                dataFilter = BracketFusionFinal(dataFilter, '9_12', '11_12', 'FNL-')
                break;
            case 'WFE_':
                dataFilter = BracketFusionSeveralPhases(dataFilter, 'FNL', 'BRN', ['REPF', 'REP4', 'REP3', 'REP2', 'REP1'])
                numMatchs = [1, 2, 2, 4, 4]
                break;
            case 'WPO':
                dataFilter = BracketFusionFinal(dataFilter, '5_8', '7_8', 'FNL-')
                break;
            case 'WRU':
                dataFilter = BracketFusionFinal(dataFilter, '5_8', '7_8', 'FNL-')
                break;
            default:
                break;
        }
    }

    let numPhasesVisibles
    switch (breakPoint) {
        case 'xs':
        case 'sm':
            numPhasesVisibles = 1;
            break;
        case 'md':
            numPhasesVisibles = 2;
            break;
        default:
            numPhasesVisibles = 3;
            break;
    }
    let swTab = dataFilter?.length > 1 ? true : false
    if (dataFilter?.length < 1) return <NotAvailable label={"LabelNoDataBracket"} />
    return (
        <>
            <LegendProvider>
                <CleanLegends />
                <div className='mirs-page-container'>
                    {swTab
                        ? <Tabs
                            id="mirs-navsport"
                            className="mb-3 mirs-tab-result"
                            activeKey={bracketKey}
                            onSelect={(k) => setBracketKey(k)}
                        >
                            {dataSportCodes && dataFilter &&
                                dataFilter
                                    .sort((a, b) => (getSportCodeObject(dataSportCodes, mirs_discipline, '@Bracket', a.bracketCode).order) - (getSportCodeObject(dataSportCodes, mirs_discipline, '@Bracket', b.bracketCode).order))
                                    .map((bracket, index) => {

                                        let bracketItems = Array.isArray(bracket?.bracketPhases) && bracket?.bracketPhases?.sort((a, b) => (getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', b.phaseCode).order) - (getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', a.phaseCode).order))
                                        let sw = bracketItems && bracketItems.length > 0
                                        Array.isArray(bracketItems) && bracketItems?.forEach((phase) => {
                                            phase.order = getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', phase.phaseCode).order
                                        })
                                        return (
                                            <Tab eventKey={`${bracket.bracketCode}`} title={getSportCodeObject(dataSportCodes, mirs_discipline, '@Bracket', bracket.bracketCode).description} key={`bracket-container-${bracket.bracketCode}`} >
                                                {sw ? <BracketDraw dataSportCodes={dataSportCodes} bracketCode={bracket.bracketCode} data={bracketItems} numPhasesVisibles={numPhasesVisibles} arrayNumMatchs={numMatchs} bracketKey={bracketKey}></BracketDraw> : ''}
                                            </Tab>
                                        )
                                    })
                            }
                        </Tabs>
                        :
                        dataSportCodes && dataFilter &&
                        [...dataFilter].map((bracket) => {
                            let bracketItems = Array.isArray(bracket?.bracketPhases) && [...bracket?.bracketPhases]?.sort((a, b) => (getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', b.phaseCode).order) - (getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', a.phaseCode).order))
                            let sw = bracketItems && bracketItems.length > 0
                            return (
                                sw && <BracketDraw key={`bracket - container - ${bracket.bracketCode}`} dataSportCodes={dataSportCodes} bracketCode={bracket.bracketCode} data={bracketItems} numPhasesVisibles={numPhasesVisibles} arrayNumMatchs={numMatchs} bracketKey={bracketKey}></BracketDraw>
                            )
                        })
                    }
                </div>
                <LegendsBox />
            </LegendProvider>
        </>
    )
}

function BracketFusionFinal(data, bracketCodeBase, bracketCodeFrom, phaseCode) {
    let otherPhases = data.find(phase => phase.bracketCode === bracketCodeBase)?.bracketPhases.filter(phase => phase.phaseCode !== phaseCode)
    let phaseBase
    let phaseFrom

    //change positions make this only in FNL- 
    if (phaseCode === 'FNL-') {
        phaseBase = { ...data.find(x => x.bracketCode === bracketCodeBase)?.bracketPhases.find(x => x.phaseCode === phaseCode)?.bracketItems.find(x => x.bi_position === "1"), bi_position: '2' }
        phaseFrom = { ...data.find(x => x.bracketCode === bracketCodeFrom)?.bracketPhases.find(x => x.phaseCode === phaseCode)?.bracketItems.find(x => x !== undefined), bi_position: '3' }
    } else {
        phaseBase = data.find(x => x.bracketCode === bracketCodeBase)?.bracketPhases.find(x => x.phaseCode === phaseCode)?.bracketItems
        phaseFrom = data.find(x => x.bracketCode === bracketCodeFrom)?.bracketPhases.find(x => x.phaseCode === phaseCode)?.bracketItems
    }

    let competitors = [
        {
            "participant": {
                "code": "NONE",
            },
            "resultItem": null
        },
        {
            "participant": {
                "code": "NONE",
            },
            "resultItem": null
        }
    ]

    let blankItem = { code: "CLEAN", bi_position: "1", bracketCompetitors: competitors }
    let phases = otherPhases


    //push final phase with matches modified
    phases && phases.push(

        {
            code: phaseBase?.code
            , phaseCode: phaseCode
            , bracketItems: phaseCode === 'FNL-' ? [{ ...blankItem }, { ...phaseBase }, { ...phaseFrom }] : [{ ...phaseBase }, { ...phaseFrom }]
        }
    )
    //add all other phases 
    let dataFilter = data.filter(x => x.bracketCode !== bracketCodeBase && x.bracketCode !== bracketCodeFrom)
    dataFilter.push(
        {
            ...data.find(x => x.bracketCode === bracketCodeBase)
            , bracketPhases: phases
        })

    return (dataFilter)
}

function BracketFusionSeveralPhases(data, bracketCodeBase, bracketCodeFrom, arrayPhaseCode) {
    let phases = []
    arrayPhaseCode.forEach(element => {
        let phaseBase = data?.find(phase => phase?.bracketCode === bracketCodeBase)?.bracketPhases?.find(phase => phase?.phaseCode === element)?.bracketItems
        let phaseFrom = data?.find(phase => phase?.bracketCode === bracketCodeFrom)?.bracketPhases?.find(phase => phase?.phaseCode === element)?.bracketItems
        phases.push(
            {
                phaseCode: element
                , code: phaseBase?.code
                , bracketItems: [...phaseBase, ...phaseFrom] //add matches modified
            }
        )
    });
    let dataFilter = data.filter(x => x.bracketCode !== bracketCodeBase && x.bracketCode !== bracketCodeFrom)
    dataFilter.push(
        {
            ...data.find(x => x.bracketCode === bracketCodeBase)
            , bracketPhases: phases
        })
    return (dataFilter)
}

export default Bracket



